import UnauthorizedErrorImage from "assets/unauthorized.svg";
import ButtonLink from "core/components/ButtonLink";
import Typography from "core/components/Typography";
import { Row } from "core/styles";
import { useLocation } from "react-router";

const UnauthorizedError = ({ url: urlProp, role: roleProp }) => {
  const location = useLocation();
  const url = urlProp ?? location.state?.url;
  const role = roleProp ?? location.state?.role;

  return (
    <div
      data-test="unauthorized-error-page"
      style={{
        height: "100%",
        margin: "0px auto",
        padding: "40px",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      <img
        src={UnauthorizedErrorImage}
        alt="unauthorized error page"
        style={{
          flexGrow: "0",
          flexShrink: "0",
        }}
      />
      <span
        style={{
          textAlign: "center",
          fontSize: "40px",
          fontWeight: "700",
          color: "var(--color-base-content)",
          maxWidth: "1014px",
        }}
      >
        You don&apos;t have access to this page or feature.
      </span>
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <span
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: "400",
            color: "var(--color-base-content)",
            maxWidth: "1014px",
          }}
        >
          This area is restricted based on your current access. If you think you
          should have permission, let us know and we&apos;ll look into it.
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            backgroundColor: "var(--input-background)",
            boxShadow: "0px 2px 4px 0px #00000040",
            padding: "24px",
            alignItems: "center",
          }}
        >
          <span style={{ fontWeight: 700, color: "var(--color-base-content)" }}>
            Access Report:
          </span>
          <Typography variant="p" noMargin color="var(--color-base-content)">
            Page URL: {url ?? "N/A"}
          </Typography>
          <Typography variant="p" noMargin color="var(--color-base-content)">
            Member Role: {role ?? "N/A"}
          </Typography>
        </div>
      </div>

      <Row>
        <ButtonLink variant="outlined" to="/">
          Return Home
        </ButtonLink>
        <ButtonLink href="https://success.populi.ai/hc/en-us">
          Contact Support
        </ButtonLink>
      </Row>
    </div>
  );
};

export default UnauthorizedError;
